import React from 'react'

const EthBig = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            fill="none"
            viewBox="0 0 50 50"
        >
            <circle cx="25" cy="25" r="25" fill="#EDF0F4"></circle>
            <path
                fill="#343434"
                d="M24.931 10l-.199.675v19.601l.2.199 9.098-5.378L24.93 10z"
            ></path>
            <path fill="#8C8C8C" d="M24.931 10l-9.098 15.097 9.098 5.378V10z"></path>
            <path
                fill="#3C3C3B"
                d="M24.932 32.197l-.112.137v6.982l.112.327 9.104-12.821-9.104 5.375z"
            ></path>
            <path
                fill="#8C8C8C"
                d="M24.931 39.643v-7.446l-9.098-5.375 9.098 12.821z"
            ></path>
            <path
                fill="#141414"
                d="M24.932 30.475l9.098-5.378-9.098-4.136v9.514z"
            ></path>
            <path
                fill="#393939"
                d="M15.833 25.097l9.098 5.378V20.96l-9.098 4.136z"
            ></path>
        </svg>
    )
}

export default EthBig